/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Operator types for filter conditions0 = Contains

1 = NotContains

2 = Equals

3 = NotEquals

4 = StartsWith

5 = EndsWith

6 = IsEmpty

7 = IsNotEmpty

8 = Before

9 = After

10 = On

11 = OnOrBefore

12 = OnOrAfter

13 = Between

14 = WithinLast

15 = MoreThan

16 = LessThanTime

17 = GreaterThan

18 = GreaterThanOrEquals

19 = LessThan

20 = LessThanOrEquals

21 = IsTrue

22 = IsFalse

23 = IsUnknown

24 = In

25 = NotIn

26 = AssignedToMe

27 = WithinNext

28 = Today

29 = InThePast


 */
export type FilterOperatorTypes =
  (typeof FilterOperatorTypes)[keyof typeof FilterOperatorTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterOperatorTypes = {
  Contains: 0,
  NotContains: 1,
  Equals: 2,
  NotEquals: 3,
  StartsWith: 4,
  EndsWith: 5,
  IsEmpty: 6,
  IsNotEmpty: 7,
  Before: 8,
  After: 9,
  On: 10,
  OnOrBefore: 11,
  OnOrAfter: 12,
  Between: 13,
  WithinLast: 14,
  MoreThan: 15,
  LessThanTime: 16,
  GreaterThan: 17,
  GreaterThanOrEquals: 18,
  LessThan: 19,
  LessThanOrEquals: 20,
  IsTrue: 21,
  IsFalse: 22,
  IsUnknown: 23,
  In: 24,
  NotIn: 25,
  AssignedToMe: 26,
  WithinNext: 27,
  Today: 28,
  InThePast: 29,
} as const;
